import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import crossIcon from "../../../Assets/images/cross_icon.png"
// css
import styles from "./ConfirmationPop.module.scss";
import DatePicker from "react-datepicker";
import moment from "moment";
import { errorMessageToast } from "helpers/common";

const ClassroomReportDateModal = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmBtnText,
  cancelBtnText,
  show,
  setShow,
  handleCopyReportApi,
  type = "classroom",
  isLoading = false,
  currentEntry
}) => {
  const [reportDate, setReportDate] = useState(null)
  const handleClose = () => {
    setReportDate(null)
    setShow(false)
  }

  const handleConfirm = async (currentEntry) => {
    if (reportDate) {
      if (type == "classroom") {
        await handleCopyReportApi(currentEntry?.id, reportDate)
      }
      else {
        await handleCopyReportApi(currentEntry?.id, currentEntry?.assesment_type, reportDate)
      }
      setReportDate(null)
    }
    else {
      errorMessageToast("Please select report date")

    }
  }

  return (
    <div className="">
      <Modal
        show={show}
        className={`${styles.ConfirmationPop} transparentModal common-confirmation-modal modal-v2`}
        onHide={onCancel}
        backdrop="static"
        keyboard={false}
        centered
        size="sm"
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <div className="text-center mx-auto">
            <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "rgb(49, 93, 153)" }}>
              <h3 className={`${styles.modalMessage} mb-0 pb-0 section-title border-bottom-0`} style={{ color: "rgb(49, 93, 153)", fontSize: "14px" }}>
                {title || "MAKE A COPY"}
              </h3>
              <img onClick={handleClose} width={16} height={16} src={crossIcon} alt="crossIcon" style={{ cursor: "pointer" }} />
            </div>
            <div>
              <DatePicker
                // {...field}
                // {...props}
                onChange={(e) => {
                  const dateFormat = moment(e).format("YYYY-MM-DD")
                  setReportDate(dateFormat)
                }}
                placeholderText='dd/mm/yyyy'
                icon={icon}
                showIcon
                onKeyDown={e => e.preventDefault()}
                autoComplete='off'
                showPopperArrow={false}
                dateFormat="MMMM d, yyyy"
                showYearDropdown
                className={`${styles.formControl} form-control`}
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                value={reportDate}
              // withPortal
              />
            </div>
            <p className="my-2 proxmia-thin text-start fw-bold" style={{ fontSize: "16px", color: "#505C6D" }}>{message || ""}</p>
            <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center d-flex justify-content-center">
              <div className="px-2">
                <Button
                  onClick={handleClose}
                  className={`${styles.modalButton} proxima-regular `}
                  disabled={isLoading}
                  style={{
                    border: "1px solid rgb(49, 93, 153)",
                    background: "white",
                    color: "#315D99",
                    padding: "8px 38px",
                    borderRadius: 2,
                  }}
                >
                  {cancelBtnText || "No"}
                </Button>
              </div>
              <div className="px-2">
                <Button
                  onClick={() => handleConfirm(currentEntry)}
                  className={`${styles.modalButton} proxima-regular`}
                  disabled={isLoading}
                  style={{
                    backgroundColor: "rgb(49, 93, 153)",
                    color: "#fff",
                    padding: "8px 38px",
                    borderRadius: 2,
                    border: 0,
                  }}
                >
                  {confirmBtnText || "Yes"}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ClassroomReportDateModal;

export const icon =
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2980_12553" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2980_12553)">
      <path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8ZM12 14C11.7167 14 11.4792 13.9042 11.2875 13.7125C11.0958 13.5208 11 13.2833 11 13C11 12.7167 11.0958 12.4792 11.2875 12.2875C11.4792 12.0958 11.7167 12 12 12C12.2833 12 12.5208 12.0958 12.7125 12.2875C12.9042 12.4792 13 12.7167 13 13C13 13.2833 12.9042 13.5208 12.7125 13.7125C12.5208 13.9042 12.2833 14 12 14ZM8 14C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12C8.28333 12 8.52083 12.0958 8.7125 12.2875C8.90417 12.4792 9 12.7167 9 13C9 13.2833 8.90417 13.5208 8.7125 13.7125C8.52083 13.9042 8.28333 14 8 14ZM16 14C15.7167 14 15.4792 13.9042 15.2875 13.7125C15.0958 13.5208 15 13.2833 15 13C15 12.7167 15.0958 12.4792 15.2875 12.2875C15.4792 12.0958 15.7167 12 16 12C16.2833 12 16.5208 12.0958 16.7125 12.2875C16.9042 12.4792 17 12.7167 17 13C17 13.2833 16.9042 13.5208 16.7125 13.7125C16.5208 13.9042 16.2833 14 16 14ZM12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17C11 16.7167 11.0958 16.4792 11.2875 16.2875C11.4792 16.0958 11.7167 16 12 16C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18ZM8 18C7.71667 18 7.47917 17.9042 7.2875 17.7125C7.09583 17.5208 7 17.2833 7 17C7 16.7167 7.09583 16.4792 7.2875 16.2875C7.47917 16.0958 7.71667 16 8 16C8.28333 16 8.52083 16.0958 8.7125 16.2875C8.90417 16.4792 9 16.7167 9 17C9 17.2833 8.90417 17.5208 8.7125 17.7125C8.52083 17.9042 8.28333 18 8 18ZM16 18C15.7167 18 15.4792 17.9042 15.2875 17.7125C15.0958 17.5208 15 17.2833 15 17C15 16.7167 15.0958 16.4792 15.2875 16.2875C15.4792 16.0958 15.7167 16 16 16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17C17 17.2833 16.9042 17.5208 16.7125 17.7125C16.5208 17.9042 16.2833 18 16 18Z" fill="#071E3E" />
    </g>
  </svg>